<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="dialog-title t-apply"></div>

                    <div class="msg-view">
                        <div class="text">
                            <p>请确认是否接受来自<b>{{ player_data.nickName }}</b>的周年绑定邀请，</p>
                            <p>首次接受邀请，立即领取以下奖励，</p>
                        </div>
                    </div>

                    <div class="reward-intro">
                        <div class="reward-list flex-center-center">

                            <div class="rb">
                                <div class="amt">X1</div>
                            </div>

                            <div class="reward-item" v-for="(r,k) in reward_list" :key="k">
                                <div class="icon-wrapper">
                                    <div class="reward-pic" v-tips="r.giftId"><game-item :locked="true" :id="r.giftId" :num="r.sendNum"></game-item></div>
                                </div>
                            </div>                            
                        </div>
                    </div>                    

                    <div class="notice">活动期间，同时只能接受一个邀请。</div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>

                    <!-- <div class="slogen-apply"></div>
                    <div class="img-patch"></div> -->
                    
                </div>
            </div>            
        </div>


        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@include responseTo("desktop"){
    .apply-modal{
        transform: scale(0.8);
    }

}

.apply-modal{
    width: 690px;
    height: 493px;
    background-image: url(~@/assets/images/modal/bg-modal-apply.png);       
}

.t-apply{
    width: 506px;
    height: 49px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/modal/title-invite-apply.png);     
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 10px 24px 0;
    line-height: 1.6;
    color: #f8e1dc;

    font-size: 22px;

    b{
        padding: 0 10px;
        color: #f2d47a;
    }    
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #ffb864;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #de482b;
}

.reward-intro{
    margin-top: 10px;
}

.reward-list{
    // margin-top: 14px;
    width: 628px;
    height: 124px;
    margin: 0 auto;
    background-image: url(~@/assets/images/modal/reward-view.png);
}


.rb{
    position: relative;
    width: 80px;
    height: 82px;
    margin: 0 20px;
    background-image: url(~@/assets/images/modal/icon-rb_sm.png);

    .status{
        position: absolute;
        top: 55px;
        left: 50%;
        transform: translateX(-50%);        
    }
}

.amt{
    position: absolute;
    top: 48px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 45px;
    height: 27px;
    line-height: 27px;
    background-image: url(~@/assets/images/modal/bg-cnt.png);
    font-size: 25px;
    color: #ffcc83;
    font-family: "HYJinKaiJ";
    font-weight: 400;
    text-align: center;
}

.reward-item{
    margin: 0 20px;
}

.icon-wrapper{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 82px;
    height: 82px;
    background-image: url(~@/assets/images/modal/bg-item_d.png);

    .reward-pic{
        width: 69px;
        height: 69px;
    }
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    gap : 20px;
}

.u-btn.ok{
    width: 255px;
    height: 83px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 255px;
    height: 83px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

// .slogen-apply{
//     width: 551px;
//     height: 31px;
//     margin: 20px auto 0;
//     background-image: url(~@/assets/images/modal/slogen-modal-apply.png);    
// }

// .img-patch{
//     width: 606px;
//     height: 192px;
//     margin: 20px auto 0;
//     background-image: url(~@/assets/images/modal/img-patch.png);
// }
</style>

<script>
import { apiBindBack , apiInviteInfo } from '@/api/index';
import inviteFlow from '@/assets/js/inviteFlow';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            score : 0,
            success : false,
            reward_list : [
                {"giftId":"AQ33","giftName":"神之队员打造书页","sendNum":"5"},
                {"giftId":"QA22","giftName":"高级防具珍材包","sendNum":"30"}
            ],
            msg : {
                1012 : '绑定失败，你已被绑定',
                1013 : '绑定失败，你已被绑定',
            }             
        }
    },
    mounted(){
        this.render();
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    inviteFlow.clearIfCode(this.code);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.destroyElement();                     
                },
            );
        },        
        closeModal () {
            const flow = inviteFlow.get();
            if(flow && flow.code === this.code && (flow.stage === 'login_pending' || flow.stage === 'invite_ready')){
                inviteFlow.clear(flow.flowId);
            }
            this.destroyElement();
        },
        apply (){

            if(!this.$store.state.login){
                inviteFlow.start(this.code);
                localStorage.setItem('code', this.code);
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                const flow = inviteFlow.get();
                const isSpecialFlow = flow && flow.code === this.code && flow.stage === 'invite_ready';
                if(isSpecialFlow)inviteFlow.setStage(flow.flowId, 'bind_pending');

                this.destroyElement();
                this.$bind_modal(isSpecialFlow ? {
                    specialInviteFlow: true,
                    inviteFlowId: flow.flowId,
                    inviteCode: this.code,
                } : {});
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            const flow = inviteFlow.get();
            const shouldShowWelcome = flow && flow.code === this.code && flow.stage === 'invite_after_bind';

            apiBindBack({ code : this.code }).then(
                res => {
                    if(shouldShowWelcome)inviteFlow.setStage(flow.flowId, 'welcome_pending', 'done');
                    else inviteFlow.clearIfCode(this.code);

                    this.$toast('绑定成功，奖励已发放至军师邮箱，请及时领取！');
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.destroyElement();

                    if(shouldShowWelcome){
                        this.$welcome_modal({
                            onClose: () => inviteFlow.clear(flow.flowId),
                        });
                    }
                },
                rej => {
                    inviteFlow.clearIfCode(this.code);
                    this.destroyElement();

                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       

                    inviteFlow.clearIfCode(this.code);
                    this.$msg_modal({ type : 'bind-error' , text :  this.msg[rej.code] || rej.message}); 
                  
                },
            );
        },                
    },
}
</script>